import { graphql, useStaticQuery } from 'gatsby';
import { NewsForList } from '@/types/cms-types';

export type UseNewsQuery = () => {
  items: NewsForList[];
};

export const useNewsQuery: UseNewsQuery = () => {
  const { allMicrocmsIpoNews } = useStaticQuery(
    graphql`
      query {
        allMicrocmsIpoNews(limit: 3) {
          nodes {
            ipoNewsId
            title
            publishedAt
            category {
              slug
              title
            }
          }
        }
      }
    `,
  );

  return {
    items: allMicrocmsIpoNews.nodes as NewsForList[],
  };
};
